// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3Rv0W","file":"styles_file__2dfWb"};